export default __webpack_public_path__ + "static/media/qana-project-2.5e4af9d3.webp";